class ProductFinder {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = 4;
    this.selections = {};
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateUI();
  }

  bindEvents() {
    // Navigation buttons
    document.getElementById('prevBtn').addEventListener('click', () => this.previousStep());
    document.getElementById('nextBtn').addEventListener('click', () => this.nextStep());
    document.getElementById('submitBtn').addEventListener('click', () => this.submitForm());

    // Radio button changes
    document.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => this.handleSelectionChange());
    });
  }

  handleSelectionChange() {
  // Store current step selection
  const currentStepElement = document.querySelector(`.step[data-step="${this.currentStep}"]`);
  const selectedRadio = currentStepElement.querySelector('input[type="radio"]:checked');
  
  if (selectedRadio) {
    this.selections[this.currentStep] = selectedRadio.value;
    this.updateNextButtonState();
    
    // Handle gender-based style filtering
    if (this.currentStep === 1 && selectedRadio.name === 'gender') {
      this.updateStyleOptions(selectedRadio.value);
    }
  }
  }

  updateNextButtonState() {
  const currentStepElement = document.querySelector(`.step[data-step="${this.currentStep}"]`);
  const selectedRadio = currentStepElement.querySelector('input[type="radio"]:checked');
  const nextBtn = document.getElementById('nextBtn');
  
  if (selectedRadio) {
    nextBtn.disabled = false;
    nextBtn.classList.remove('btn:disabled');
  } else {
    nextBtn.disabled = true;
    nextBtn.classList.add('btn:disabled');
  }
  }

  updateStyleOptions(genderValue) {
    const pantyhoseOption = document.querySelector('label[for="style-pantyhose"]');
    const maternityOption = document.querySelector('label[for="style-maternity"]');
    
    if (genderValue === "Men's") {
      // Hide Pantyhose and Maternity options for Men's
      if (pantyhoseOption) {
        pantyhoseOption.style.display = 'none';
        // Clear selection if it was selected
        const pantyhoseInput = document.getElementById('style-pantyhose');
        if (pantyhoseInput && pantyhoseInput.checked) {
          pantyhoseInput.checked = false;
        }
      }
      if (maternityOption) {
        maternityOption.style.display = 'none';
        // Clear selection if it was selected
        const maternityInput = document.getElementById('style-maternity');
        if (maternityInput && maternityInput.checked) {
          maternityInput.checked = false;
        }
      }
    } else {
      // Show all options for Women's and Unisex
      if (pantyhoseOption) {
        pantyhoseOption.style.display = '';
      }
      if (maternityOption) {
        maternityOption.style.display = '';
      }
    }
  }

  nextStep() {
  if (this.currentStep < this.totalSteps) {
    // Validate current step has selection
    const currentStepElement = document.querySelector(`.step[data-step="${this.currentStep}"]`);
    const selectedRadio = currentStepElement.querySelector('input[type="radio"]:checked');
    
    if (!selectedRadio) {
    this.showError('Please make a selection before continuing.');
    return;
    }

    this.currentStep++;
    this.updateUI();
  }
  }

  previousStep() {
  if (this.currentStep > 1) {
    this.currentStep--;
    this.updateUI();
  }
  }

  updateUI() {
  // Update step visibility
  document.querySelectorAll('.step').forEach((step, index) => {
    step.classList.toggle('active', parseInt(step.dataset.step) === this.currentStep);
  });

  // Update progress
  const progressPercentage = (this.currentStep / this.totalSteps) * 100;
  document.getElementById('progressFill').style.width = `${progressPercentage}%`;
  
  // Update progress text
  document.querySelector('.step-counter').textContent = `Step ${this.currentStep} of ${this.totalSteps}`;
  document.querySelector('.completion-percentage').textContent = `${Math.round(progressPercentage)}% Complete`;

  // Update button visibility
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  const submitBtn = document.getElementById('submitBtn');

  prevBtn.style.display = this.currentStep > 1 ? 'inline-block' : 'none';
  
  if (this.currentStep === this.totalSteps) {
    nextBtn.style.display = 'none';
    submitBtn.style.display = 'inline-block';
  } else {
    nextBtn.style.display = 'inline-block';
    submitBtn.style.display = 'none';
  }

  // Apply gender-based filtering when reaching step 3
  if (this.currentStep === 3 && this.selections[1]) {
    this.updateStyleOptions(this.selections[1]);
  }

  // Update next button state
  this.updateNextButtonState();
  }

  submitForm() {
  // Validate all steps have selections
  if (Object.keys(this.selections).length < this.totalSteps) {
    this.showError('Please complete all steps before viewing recommendations.');
    return;
  }

  // Construct search URL
  const searchValues = Object.values(this.selections);
  const searchQuery = searchValues.map(value => encodeURIComponent(value)).join(', ');
  const searchUrl = `/search?type=product&q=${searchQuery}`;

  // Navigate to search results
  window.location.href = searchUrl;
  }

  showError(message) {
  // Simple error display - could be enhanced with a toast notification
  alert(message);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductFinder();
});